// extracted by mini-css-extract-plugin
export var layoutContainer = "_6e-0";
export var layoutContainerNoRounding = "_6e-6";
export var layoutContainerOpen = "_6e-5";
export var layoutContainerResizing = "_6e-1";
export var mainContent = "_6e-2";
export var resizeDivider = "_6e-3";
export var slidePanel = "_6e-4";